import { render, staticRenderFns } from "./addUser.vue?vue&type=template&id=00252624&scoped=true&"
import script from "./addUser.vue?vue&type=script&lang=js&"
export * from "./addUser.vue?vue&type=script&lang=js&"
import style0 from "./addUser.vue?vue&type=style&index=0&id=00252624&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00252624",
  null
  
)

export default component.exports